export default "skymp5-front/9daf4db75b4c8a2bb5a817f052e4d7a9.svg";